import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'GET_ALL_ACTIVITY_TYPES';

export async function getAllActivityTypes(userToken: string, params: string, page: number) {
    try {
        const response = await axios.get(
            `${URL}/activity-types/?page=${page}${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des types d\'activités',
            error: error
        });
    }
}
